import React, { useState } from "react";
import "../../assets/css/tables.css";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import course from "../../assets/images/courses/Cours.svg";
import student from "../../assets/images/courses/student.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import Repository from "../../configs/axios/repository";

import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";

const CourseTable = ({
    courses,
    refreshTable,
    setLoadingData,
    loadingData,
    role,
}) => {
    const history = useHistory();
    const deleteCourse = async (courseId) => {
        const result = await Repository.deleteById(
            `api/course/deleteCourse/${courseId}`
        );
        if (result.data?.success == true) {
            refreshTable();
            loadingData
                ? Swal.fire(
                      "Deleted!",
                      "Your file has been deleted.",
                      "success"
                  )
                : "";
        }
    };
    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingData(false);
                deleteCourse(id);
            }
            setLoadingData(true);
        });
    }
    function students(id, courseName) {

        history.push({
            pathname: "/courseStudents",
            search: `course_id=${id}`,
            state: { courseName },
        });
    }

    function courseTests(id, courseName) {
        localStorage.setItem("course_id", id);

        history.push({
            pathname: "/courseDetails",
            search: `course_id=${id}`,
            state: { courseName },
        });
    }
    const thumbs = courses.map((file, i) => {
        return (
            <div key={i}>
                <div
                    className="parentCoursesDiv"
                    onClick={() => {
                        courseTests(file.course_id, file.course_name);
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={course} alt="course" />
                        </div>
                        <div className="mt-3">
                            <span>{file.course_name}</span>
                            {role == "instructor" ? (
                                <p>
                                    {file.description
                                        ? file.description.length < 50
                                            ? file.description.slice(0, 50)
                                            : file.description.slice(0, 50) +
                                              "..."
                                        : ""}
                                </p>
                            ) : (
                                <p>
                                    {file.instructor_name
                                        ? file.instructor_name
                                        : ""}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
                {role == "instructor" ? (
                    <div className="childCourse2Dive">
                        <div>
                            <UncontrolledDropdown className="dropdown-user nav-item actionContent">
                                <DropdownToggle
                                    tag="a"
                                    className="nav-link dropdown-user-link pointsCourse"
                                >
                                    <img src={more_vert} alt="points" />
                                </DropdownToggle>
                                <DropdownMenu end className="dropMenu">
                                    <DropdownItem
                                        onClick={(e) => {
                                            handleDelete(file.course_id);
                                        }}
                                    >
                                        <div className="actionsMenuCourse">
                                            <img
                                                src={deletes}
                                                alt="deletes"
                                                className="del"
                                            />
                                            <span>Delete</span>
                                        </div>
                                    </DropdownItem>{" "}
                                    <DropdownItem
                                        onClick={(e) => {
                                            students(
                                                file.course_id,
                                                file.course_name
                                            );
                                        }}
                                    >
                                        <div className="actionsMenuCourse">
                                            <img
                                                src={student}
                                                alt="student"
                                                className="del"
                                            />
                                            <span>Students</span>
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    });
    return <div className="divTable">{thumbs}</div>;
};

export default CourseTable;
